import { render, staticRenderFns } from "./TabsSelect.vue?vue&type=template&id=450050af&"
import script from "./TabsSelect.vue?vue&type=script&lang=js&"
export * from "./TabsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports